/**
 * Resolves immutable application media. Leaving the origin unset preserves the
 * same-origin paths used by local development, Docker, and existing installs.
 * A release can set VITE_TBLTOP_MEDIA_ORIGIN to serve this large, versioned
 * library from a dedicated static host without changing campaign data.
 */
function configuredMediaOrigin() {
  const value = import.meta.env.VITE_TBLTOP_MEDIA_ORIGIN?.trim();
  if (!value) return "";
  try {
    const origin = new URL(value);
    return origin.protocol === "https:" || origin.protocol === "http:" ? origin.toString().replace(/\/+$/, "") : "";
  } catch {
    return "";
  }
}

export const TBLTOP_MEDIA_ORIGIN = configuredMediaOrigin();

/** Only bundled, immutable application assets may move to the media host. */
export function mediaUrl(path: string) {
  if (!TBLTOP_MEDIA_ORIGIN || !path.startsWith("/")) return path;
  if (!path.startsWith("/assets/") && !path.startsWith("/default-media/")) return path;
  return `${TBLTOP_MEDIA_ORIGIN}${path}`;
}
